// Single source of per-route SEO, shared by useSEO (runtime) and scripts/prerender.js (build).
import { FAQS, ARTICLES } from "./constants";

const SITE = "https://4ever.co.in";
const crumbs = (...items) => [{ name: "Home", path: "/" }, ...items.map(([name, path]) => ({ name, path }))];
const toISO = (d) => new Date(`${d} 00:00:00 GMT+0530`).toISOString().slice(0, 10);
const titleCase = (s) => s.charAt(0) + s.slice(1).toLowerCase();

export const SEO = {
  home: {
    title: "Disposable Period Panties & Women's Wellness in India",
    description: "4ever is a women's wellness home from India — leak-proof disposable period panties, a free cycle tracker and a private community for PCOS, fertility and more.",
    path: "/",
    breadcrumbs: crumbs(),
  },
  product: {
    title: "Buy Disposable Period Panties Online — Pack of 5 at ₹299",
    description: "Shop 4ever Freedom disposable period panties: leak-proof for up to 12 hours depending on usage, soft cotton, OEKO-TEX certified. 5 sizes S–XXXL. Free shipping over ₹999, COD available.",
    path: "/product",
    type: "product",
    imageAlt: "4ever Freedom Disposable Period Panties — pack of 5",
    breadcrumbs: crumbs(["Shop", "/product"], ["Disposable Period Panties", "/product"]),
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Product",
      name: "4Ever Freedom Disposable Period Panties",
      description: "Soft, leak-proof disposable period panties. Full-brief cut, dermatologist tested, OEKO-TEX Standard 100 certified. Up to 12 hours of wear depending on usage.",
      brand: { "@type": "Brand", name: "4Ever" },
      image: ["g1_hero", "g2_size", "g3_compare", "g4_comfort"].map(n => `${SITE}/img/${n}.webp`),
      sku: "4EVER-DPP-5PK",
      mpn: "4EVER-DPP-5PK",
      category: "Feminine hygiene / Period care",
      size: ["S-M", "M-L", "L-XL", "XL-XXL", "XXL-XXXL"],
      countryOfOrigin: "IN",
      manufacturer: { "@type": "Organization", name: "NASIBDAR CONSUMER PRODUCTS LLP" },
      offers: {
        "@type": "Offer",
        priceCurrency: "INR",
        price: "299",
        priceValidUntil: "2026-12-31",
        url: `${SITE}/product`,
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        seller: { "@type": "Organization", name: "4Ever" },
        acceptedPaymentMethod: ["https://schema.org/COD", "https://schema.org/PaymentCard"],
        hasMerchantReturnPolicy: {
          "@type": "MerchantReturnPolicy",
          applicableCountry: "IN",
          returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
          merchantReturnDays: 7,
          returnMethod: "https://schema.org/ReturnByMail",
        },
        shippingDetails: {
          "@type": "OfferShippingDetails",
          shippingDestination: { "@type": "DefinedRegion", addressCountry: "IN" },
          deliveryTime: {
            "@type": "ShippingDeliveryTime",
            handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 1, unitCode: "DAY" },
            transitTime: { "@type": "QuantitativeValue", minValue: 3, maxValue: 5, unitCode: "DAY" },
          },
        },
      },
    },
  },
  faq: {
    title: "FAQ — Sizes, Shipping, Returns & Subscriptions",
    description: "Answers to common 4ever questions: period panty sizes, wear time, sensitive skin, subscriptions, tracker-synced delivery, data privacy, COD, shipping and returns.",
    path: "/faq",
    breadcrumbs: crumbs(["FAQ", "/faq"]),
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map(f => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  },
  community: {
    title: "Women's Health Community — PCOS, Fertility & Periods",
    description: "Join 4ever's private, moderated women's health community. Ask anonymously about PCOS, first periods, endometriosis, fertility, postpartum and menopause.",
    path: "/community",
    breadcrumbs: crumbs(["Community", "/community"]),
  },
  journal: {
    title: "The Journal — Period, PCOS & Hormone Health Guides",
    description: "Read the 4ever Journal: expert-backed guides on periods, PCOS, fertility, hormones, iron-rich nutrition, rest and PMS anxiety for Indian women.",
    path: "/journal",
    image: "/img/journal.png",
    imageAlt: "The 4ever Journal",
    breadcrumbs: crumbs(["Journal", "/journal"]),
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "The 4ever Journal",
      url: `${SITE}/journal`,
      blogPost: ARTICLES.map(a => ({
        "@type": "BlogPosting", headline: a.title, url: `${SITE}/journal/${a.slug}`, datePublished: toISO(a.date),
      })),
    },
  },
  story: {
    title: "Our Story — Women's Wellness Made in Mumbai",
    description: "Meet 4ever: a women's wellness brand by Nasibdar, a Mumbai manufacturer with 25 years in hygiene products. ISO, BIS and OEKO-TEX certified, made in India.",
    path: "/story",
    image: "/img/story.png",
    imageAlt: "The people behind 4ever",
    breadcrumbs: crumbs(["Our Story", "/story"]),
  },
  sizeguide: {
    title: "Period Panty Size Guide — Waist & Hip Chart (S to XXXL)",
    description: "Find your 4ever period panty size. Waist and hip chart in inches for S-M, M-L, L-XL, XL-XXL and XXL-XXXL, plus tips on choosing between two sizes.",
    path: "/sizeguide",
    image: "/img/g2_size.webp",
    imageAlt: "4ever period panty size chart",
    breadcrumbs: crumbs(["Shop", "/product"], ["Size Guide", "/sizeguide"]),
  },
  tracker: {
    title: "Cycle Tracker — A tracker that guides, never nags",
    description: "A free women's wellness cycle tracker from 4Ever. Log how you feel in 20 seconds a day, learn your rhythm, predict your next period, and sync your delivery.",
    path: "/tracker",
    breadcrumbs: crumbs(["Tracker", "/tracker"]),
  },
  privacy: {
    title: "Privacy Policy",
    description: "How 4ever by Nasibdar Consumer Products LLP collects, uses and protects your personal and cycle data under India's DPDP Act 2023 and IT Act 2000.",
    path: "/privacy",
    breadcrumbs: crumbs(["Privacy Policy", "/privacy"]),
  },
  terms: {
    title: "Terms of Service",
    description: "Terms for shopping at 4ever: orders, COD, free shipping over ₹999, 7-day returns, subscriptions, Bloom Points and community guidelines.",
    path: "/terms",
    breadcrumbs: crumbs(["Terms of Service", "/terms"]),
  },
};

export function articleSEO(a) {
  const path = `/journal/${a.slug}`;
  return {
    title: a.title,
    description: `${a.excerpt} From the 4ever Journal.`,
    path,
    type: "article",
    image: "/img/journal.png",
    imageAlt: a.title,
    breadcrumbs: crumbs(["Journal", "/journal"], [a.title, path]),
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: a.title,
      description: a.excerpt,
      articleSection: titleCase(a.cat),
      datePublished: toISO(a.date),
      mainEntityOfPage: `${SITE}${path}`,
      author: { "@type": "Organization", name: "The 4Ever Editorial Team" },
      publisher: { "@type": "Organization", name: "4Ever", logo: { "@type": "ImageObject", url: `${SITE}/img/g1_hero.webp` } },
      image: `${SITE}/img/journal.png`,
      inLanguage: "en-IN",
    },
  };
}
